<span (click)="orderColumn()" class="ordenable">
	<strong>{{ title | translate }}</strong>
	<span
		class="sort-icon"
		*ngIf="sortable"
		[ngClass]="{
			'sort-icon-up': table.isSortedColumnAsc(prop),
			'sort-icon-down': table.isSortedColumnDesc(prop)
		}"
	></span>
</span>
